var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('div',{staticClass:"func-item"},[_c('span',{staticClass:"ui-ico sfi icon-overdue-refund2"}),_vm._v(" "),_c('span',{staticClass:"ui-btn-right"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm._ll('代表支持超时退费')))]),_c('span',{staticClass:"ui-ico ui-ico-right"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b3a75fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/payFee/additionalService/overdue-refund.vue
// module id = null
// module chunks = 